import { render } from "./HR_WarningType_Dialog.vue?vue&type=template&id=be4c034a&ts=true"
import script from "./HR_WarningType_Dialog.vue?vue&type=script&lang=ts"
export * from "./HR_WarningType_Dialog.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__